<template>
    <label-input
        :label="cost.title || 'Number in party'"
        type="number"
        :input-class="['numberInput']"
        v-model="n_people"
        :validator="$v.n_people"
        :error-message="n_people > 0 ? `Only ${cost.n_max} spots available in this category` : 'Enter a valid count.'"
    />
</template>

<script>
import LabelInput from '../../_components/form/LabelInput.vue';
import { validationMixin } from 'vuelidate';
import { minValue, integer } from 'vuelidate/lib/validators';

const notTooMany = function(n_people) {
    return this.cost.n_max === null ? true : (n_people <= this.cost.n_max);
};

export default {
    components: {
        LabelInput,
    },
    mixins: [ validationMixin ],
    props: {
        cost: {
            type: Object,
        },
        spots_available: {
            type: Number,
        },
    },
    data: function () {
        return {
            n_people: null,
        };
    },
    validations() {
        return {
            n_people: {
                integer,
                minValue: minValue(0),
                notTooMany,
            },
        };
    },
    watch: {
        n_people(cur) {
            this.$emit('input', cur)
        },
    },
}
</script>

<style lang="scss">
</style>
